import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { EntityDataObject } from 'models/service';

export const joinCommunity = async ({ id, reason }: { id: string; reason?: string }) =>
  apiClient.post<EntityDataObject, ApiClientResponse<EntityDataObject>>(routes.community.join(id), {
    reason,
  });
